import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import OnboardingModal from '../components/OnboardingModal';

const PrivacyHubPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

      <main style={{ padding: '60px 0 80px 0' }}>
        <div className="jmi-container" style={{ maxWidth: '900px' }}>
          <div className="section-header-center">
            <div className="section-label">DATA PROTECTION & PRIVACY</div>
            <h1 className="section-title">
              JMI Privacy & <span className="gold-gradient-text">Compliance Hub</span>
            </h1>
            <p className="section-subtitle">
              We treat high-value B2B commercial data with bank-grade encryption, role-based access, and strict confidentiality.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px', marginBottom: '40px' }}>
            <div className="jmi-card">
              <h3 style={{ color: '#FFFFFF', marginBottom: '10px' }}>Buyer Privacy Policy</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.88rem', lineHeight: '1.5', marginBottom: '20px' }}>
                Covers how purchasing volumes, GST data, showroom locations, and payment credentials are protected.
              </p>
              <Link to="/buyerprivacy" className="btn btn-outline-gold btn-sm w-full">
                View Buyer Policy →
              </Link>
            </div>

            <div className="jmi-card">
              <h3 style={{ color: '#FFFFFF', marginBottom: '10px' }}>Seller Privacy Policy</h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.88rem', lineHeight: '1.5', marginBottom: '20px' }}>
                Details protection of proprietary CAD designs, making charge matrices, and inventory valuation data.
              </p>
              <Link to="/sellerprivacy" className="btn btn-primary btn-sm w-full">
                View Seller Policy →
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default PrivacyHubPage;
